class Timer {
  public isPlaying: boolean
  private currentDuration: number
  private totalDuration: number
  private playCallback?: () => void
  private pauseCallback?: () => void
  private endCallback?: () => void
  private timeoutId: number
  private startTime: number

  constructor (duration: number, playCallback?: () => void, pauseCallback?: () => void, endCallback?: () => void) {
    this.isPlaying = false
    this.currentDuration = duration
    this.totalDuration = duration
    this.playCallback = playCallback
    this.pauseCallback = pauseCallback
    this.endCallback = endCallback
  }

  public play() {
    if (this.isPlaying) {
      return
    }

    // Mark original starting time
    this.startTime = new Date().getTime()

    this.isPlaying = true
    this.timeoutId = window.setTimeout(this.end.bind(this), this.currentDuration)

    if (this.playCallback) {
      this.playCallback()
    }
  }

  public pause() {
    if (!this.isPlaying) {
      return
    }

    const elapsedTime = new Date().getTime() - this.startTime
    delete(this.startTime)
    
    window.clearTimeout(this.timeoutId)
    delete(this.timeoutId)
    this.currentDuration -= elapsedTime
    this.isPlaying = false

    if (this.pauseCallback) {
      this.pauseCallback()
    }
  }

  public stop() {
    window.clearTimeout(this.timeoutId)
    delete(this.timeoutId)
  }

  public end() {
    window.clearTimeout(this.timeoutId)
    delete(this.timeoutId)

    if (this.endCallback) {
      this.endCallback()
    }
  }

  public getPercentageComplete() {
    const elapsedTime = new Date().getTime() - this.startTime
    const percentage = (this.totalDuration - (this.currentDuration - elapsedTime)) / this.totalDuration

    return Number(percentage.toPrecision(2))
  }
}

export default Timer


// WEBPACK FOOTER //
// ./src/Timer.ts